module.exports = __webpack_public_path__ + "img/prize.022f83e8.png";